import { useQuery } from '@tanstack/react-query';

import { purchasesApi } from '@entities/purchase/api';
import { getIdFromUrlPath } from '@shared/helpers';

export const useGetPurchaseChartInfoQuery = () => {
    const estimateId = getIdFromUrlPath('estimate');

    return useQuery(purchasesApi.getPurchaseChartInfoQueryOptions({ estimateId }));
};
